import React, { useEffect, useMemo, useRef, useState } from "react";

// constants
import { addMinutesToTime, combineDateAndTimeToISO, formatTime, getFullDayName, getTimeSlotKey } from "./constants";

// apis
import { getCalendarSlotStartTime, postCalendarEvent } from "../../../js/api/events";

// store
import { useDispatch } from "react-redux";
import { getWorkflowTrialById } from "../../../reducer/slices/workflow/get-workflow-by-id";

const AddEvent = ({
  patient = {},
  recruiters = [],
  availableTimes,
  selectedDate,
  now,
  onCancel,
  selectedRecriuter,
  setSelectedRecriuter,
  currentMonth,
  currentYear,
  selectedDay,
  slotStartTime,
  setCurrentMonth,
  setCurrentYear,
  setSelectedDay,
  setSelectedDate,
  setSlotStartTime,
  setSlotFilter,
  slotFilter,
  selectedTime,
  currentHour,
  currentMinute,
  roundedMinute,
  formattedTime,
  setSelectedTime,
  timeSlotGroups,
  slotLoader,
  setSlotLoader,
  operationalData,
  toasts,
  setToasts,
  id,
  isCalenderRecriuterLoading
}) => {
  const selectedRef = useRef(null);
  const dispatch = useDispatch()
  const [payload, setPayload] = useState();
  const [errors, setErrors] = useState({
    patientTrialJuncID: '',
    recruiterID: '',
    eventTime: '',
    selectedDate: ''
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState({
    btnEvent: false
  });

  useEffect(() => {
    if (recruiters && recruiters.length || operationalData && operationalData.length) {

    } else {
      dispatch(getWorkflowTrialById({ id }))
    }
  }, []);
  useEffect(() => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const roundedMinute = currentMinute < 30 ? "00" : "30";
    const formattedTime = `${String(currentHour).padStart(2, "0")}:${roundedMinute}`;

    const month = now.getMonth();
    const year = now.getFullYear();
    const date = now.getDate();

    setCurrentMonth(month);
    setCurrentYear(year);
    setSelectedDate(date);
    setSelectedTime(availableTimes.includes(formattedTime) ? formattedTime : availableTimes[0]);
    getCalendarSlotStartTime(selectedRecriuter, setSlotStartTime, setSlotLoader)
  }, []);

  useEffect(() => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const roundedMinute = currentMinute < 30 ? "00" : "30";
    const formattedTime = `${String(currentHour).padStart(2, "0")}:${roundedMinute}`;
    const selectedFullDate = new Date(currentYear, currentMonth, selectedDate);
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (selectedFullDate.getTime() === todayDate.getTime()) {
      setSelectedTime(availableTimes.includes(formattedTime) ? formattedTime : availableTimes[0]);
    } else if (selectedFullDate.getTime() > todayDate.getTime()) {
      setSelectedTime(availableTimes[0]);
    }
    // setSelectedTime(availableTimes.includes(formattedTime) ? formattedTime : availableTimes[0]);
  }, [selectedDate])

  useEffect(() => {
    const selectSlotSession = getTimeSlotKey(selectedTime, timeSlotGroups);
    setSlotFilter(selectSlotSession)
    if (selectedRef.current) {
      selectedRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [selectedTime]);

  useEffect(() => {
    setSelectedDay(getFullDayName(new Date(currentYear, currentMonth, now.getDate())));
  }, [currentMonth, currentYear, selectedDate])

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const availableDates = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const changeMonth = (step) => {
    let newMonth = currentMonth + step;
    let newYear = currentYear;

    if (newMonth < 0) {
      newMonth = 11;
      newYear -= 1;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear += 1;
    }

    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
  };

  useEffect(() => {
    const combinedDate = combineDateAndTimeToISO(currentYear, currentMonth, selectedDate, selectedTime);
    const payload = {
      "patientTrialJuncID": patient.patientTrialJuncID,
      "recruiterID": selectedRecriuter,
      "eventTime": combinedDate
    }
    setPayload(payload)
  }, [selectedRecriuter, currentYear, currentMonth, selectedTime, patient])


  const {
    isToday,
    currentMinutes,
    parsedStartDate,
    isSameDayAsStartTime,
    startMinutes
  } = useMemo(() => {
    const now = new Date();

    const todayCheck =
      selectedDate === now.getDate() &&
      currentMonth === now.getMonth() &&
      currentYear === now.getFullYear();

    let parsedStartDate = null;
    let isSameDayAsStartTime = false;
    let startMinutes = 0;

    if (slotStartTime?.startTime) {
      parsedStartDate = new Date(slotStartTime.startTime);
      isSameDayAsStartTime =
        selectedDate === parsedStartDate.getDate() &&
        currentMonth === parsedStartDate.getMonth() &&
        currentYear === parsedStartDate.getFullYear();
      startMinutes =
        parsedStartDate.getHours() * 60 + parsedStartDate.getMinutes();
    }

    return {
      isToday: todayCheck,
      currentMinutes: now.getHours() * 60 + now.getMinutes(),
      parsedStartDate,
      isSameDayAsStartTime,
      startMinutes
    };
  }, [slotStartTime?.startTime, selectedDate, currentMonth, currentYear]);
  const validatePayload = () => {
    const newErrors = {
      patientTrialJuncID: '',
      recruiterID: '',
      eventTime: '',
      selectedDate: '',
    };

    let isValid = true;

    if (!payload.patientTrialJuncID) {
      newErrors.patientTrialJuncID = 'Patient Trial Junction ID is required.';
      isValid = false;
    }

    if (!payload.recruiterID) {
      newErrors.recruiterID = 'Recruiter is required.';
      isValid = false;
    }
    if (!selectedDate) {
      newErrors.selectedDate = 'Date is required.';
      isValid = false;
    }

    if (!payload.eventTime) {
      newErrors.eventTime = 'Slot Time is required.';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const onAddEvent = async () => {

    if (!validatePayload()) return;

    try {
       setIsButtonDisabled({ ...isButtonDisabled, btnEvent: true });
      const result = await postCalendarEvent(payload, addToast);

      if (result) {
        onCancel()
      } else {
        // API returned null, possibly due to error in try-catch
        // setErrorMessage('Failed to schedule the event. Please try again.');
      }
    } catch (error) {
      console.error('Unexpected error:', error);
    }
    finally {
      setIsButtonDisabled({ ...isButtonDisabled, btnEvent: false });
    }
  }

  const onslotfilterClicked = (key) => {
    const filterSlots = timeSlotGroups[key];
    const startTimeInMinutes = filterSlots.start;
    const endTimeInMinutes = filterSlots.end;
    const selectedSlot = availableTimes.find(time => {
      const [hours, mins] = time.split(':').map(Number);
      const timeInMinutes = hours * 60 + mins;

      // Handle wrap-around (evening slot end is before start, e.g., 1140 to 300)
      if (endTimeInMinutes < startTimeInMinutes) {
        return timeInMinutes >= startTimeInMinutes || timeInMinutes < endTimeInMinutes;
      } else {
        return timeInMinutes >= startTimeInMinutes && timeInMinutes < endTimeInMinutes;
      }
    });

    if (selectedSlot) {
      setSelectedTime(selectedSlot);
    } else {
      setSelectedTime(undefined); // or null, depending on your logic
    }

    setSlotFilter(key);
  };

  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay(); // 0 (Sun) - 6 (Sat)
  // const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const calendarDays = [
    ...Array(firstDayOfMonth).fill(null),
    ...Array.from({ length: daysInMonth }, (_, i) => i + 1)
  ];

  const thisDate = new Date(currentYear, currentMonth, 1);
  const today = new Date();
  const isCurrentMonthAndYear =
    thisDate.getFullYear() === today.getFullYear() &&
    thisDate.getMonth() === today.getMonth();

  return (
    <div className="max-w-[1100px] mx-auto bg-white p-6 rounded-xl shadow-md">
      <h2 className="text-xl font-medium mb-4 heading-text-color">Add Event</h2>
      <div className="flex gap-4 border-t border-b">
        {/* Left Section */}
        <div className="w-[289px] border-r  pr-4 py-[30px]">
          <div className="mb-4">
            <p className="heading-text-color font-medium">Patient Name</p>
            <p className="text-black">{patient.patientName || "N/A"}</p>
          </div>
          <div className="mb-4">
            <p className="heading-text-color font-medium">Contact</p>
            <p className="text-black">{patient.phoneNumber || "N/A"}</p>
          </div>
          <div className="mb-4">
            <p className="heading-text-color font-medium">Trial Name</p>
            <p className="text-black">{patient.trialName || "N/A"}</p>
          </div>
          <div className="w-full relative">
            <p className="heading-text-color font-medium mb-3">
              Select Recruiter <span className="text-red-500">*</span>
            </p>
            <div className="border_color border text-base rounded-lg block w-full p-0 appearance-none mb-4">
              <select
                id="recruiterId"
                name="recruiterId"
                value={selectedRecriuter}
                onChange={(e) => { setSelectedRecriuter(e.target.value) }}
                className="text-base rounded-lg block w-full p-2 h-12 appearance-none max-h-[46px]"
              >
                <option value="" disabled selected>
                  Select a recruiter
                </option>
                {recruiters&&recruiters.length&&recruiters.map((rd) => (
                  <option key={rd.recruiterID} value={rd.recruiterID}>
                    {rd.fullName}
                  </option>
                ))}
              </select>
              <span className="absolute right-[20px] top-[62px] transform -translate-y-1/2 pointer-events-none">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>
            {errors.recruiterID && <p className="text-red-500 text-sm">{errors.recruiterID}</p>}
          </div>
        </div>
        {/* Middle Calendar Section */}
        <div className="w-[453px] border-r px-4">
          {/* Header */}
          <div className="flex justify-between items-center py-[30px]">
            <h3 className="font-medium text-lg">
              {months[currentMonth]} {currentYear}
            </h3>
            <div className="flex justify-between items-center">
              <button onClick={() => changeMonth(-1)} className={`p-2 ${isCurrentMonthAndYear?' text-gray-400 cursor-not-allowed':''}`} disabled={isCurrentMonthAndYear}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                  <path d="M10.0313 2.7193L5.68458 7.06596C5.17125 7.5793 5.17125 8.4193 5.68458 8.93263L10.0312 13.2793" stroke={`${isCurrentMonthAndYear?'#9CA3AF':'#373737'}`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <button onClick={() => changeMonth(1)} className="p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                  <path d="M5.96875 2.7193L10.3154 7.06596C10.8288 7.5793 10.8288 8.4193 10.3154 8.93263L5.96875 13.2793" stroke="#373737" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>

          {/* Day Labels */}
          <div className="grid grid-cols-7 text-center text-sm text-gray-500 font-medium mb-2">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
              <div key={day} className="mb-1 mr-[18px]">{day}</div>
            ))}
          </div>

          {/* Dates Grid */}
         {isCalenderRecriuterLoading?<div className="w-full h-full mt-[35%] flex justify-center "><div className="mini-spinner"></div></div>: <div className="grid grid-cols-7 gap-2 mt-2">
            {calendarDays.map((day, index) => {
              if (day === null) {
                return <div key={`empty-${index}`} />;
              }

              const thisDate = new Date(currentYear, currentMonth, day);
              const dayOfWeek = thisDate.toLocaleDateString("en-US", { weekday: "long" });
              const daySetting = operationalData && operationalData.length && operationalData.find(d => d.day === dayOfWeek);
              const isEnabled = daySetting?.isChecked ?? false;
              const isPast = thisDate < new Date(now.getFullYear(), now.getMonth(), now.getDate());
              const isDisabled = isPast || !isEnabled;

              return (
                <button
                  key={day}
                  disabled={isDisabled}
                  className={`w-[34px] h-[34px] flex items-center justify-center rounded-full
                ${isDisabled
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : selectedDate === day
                        ? "bg-[#278EFF] text-white"
                        : "bg-gray-200 text-gray-700 hover:bg-[#278EFF]/20"
                    }`}
                  onClick={() => !isDisabled && setSelectedDate(day)}
                >
                  {day}
                </button>
              );
            })}
          </div>}
          {errors.selectedDate && <p className="text-red-500 text-sm mt-5">{errors.selectedDate}</p>}
        </div>

        {/* Right Time Slot Section */}
        <div className="w-[289px] px-4 py-[30px]">
          <div className="flex justify-between mb-4 bg-gray-100 rounded-lg">
            {Object.keys(timeSlotGroups).map((key, i) => (
              <button
                key={key}
                onClick={() => onslotfilterClicked(key)}
                className={`flex-1 text-center px-4 py-2 ${i === 0 ? "rounded-l-lg" : i === 2 ? "rounded-r-lg" : ""} transition-all
        ${slotFilter === key ? "bg-[#278EFF] text-white rounded-lg" : "bg-gray-100 text-black"}`}
              >
                <div className="text-xl mb-1 flex justify-center">
                  {timeSlotGroups[key].icon}
                </div>
              </button>
            ))}
          </div>
          <h3 className="text-[#278EFF] font-semibold">
            <h3 className="text-[#278EFF] font-semibold">
              {new Date(currentYear, currentMonth, selectedDate).toLocaleDateString("en-US", {
                weekday: "short", // or "long"
              })}{" "}
              {new Date(currentYear, currentMonth, selectedDate).toLocaleDateString("en-US", {
                day: "numeric",
              })}
            </h3>
          </h3>

          <div className="mt-4 h-64 overflow-y-auto pr-2">
            {slotLoader ? <div className="flex justify-center" ><div className="mini-spinner "></div></div> : (availableTimes.map((time) => {
              const [hour, minute] = time.split(":").map(Number);
              const timeValue = hour * 60 + minute;

              const isPast = isToday && timeValue <= currentMinutes;
              const isBeforeStartTime =
                parsedStartDate && isSameDayAsStartTime && timeValue < startMinutes;

              const shouldDisable = isPast || isBeforeStartTime;
              if (time === selectedTime && shouldDisable) {
                // selectedTime

                const nextSlot = addMinutesToTime(selectedTime, 30);
                const isNextSlotAvailable = availableTimes.find(i => i === nextSlot);
                if (isNextSlotAvailable) {
                  setSelectedTime(nextSlot)
                } else {
                  setSelectedTime()
                }
              }

              return (
                <button
                  key={time}
                  ref={selectedTime === time ? selectedRef : null}
                  className={`w-full p-2 my-1 rounded-lg text-center ${selectedTime === time
                    ? "bg-[#278EFF] text-white"
                    : shouldDisable
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white border border-[#E4E4E4] hover:bg-[#278EFF]-100"
                    }`}
                  onClick={() => !shouldDisable && setSelectedTime(time)}
                  disabled={shouldDisable}
                >
                  {formatTime(time)}
                </button>
              );
            }))}

          </div>
          {errors.eventTime && <p className="text-red-500 text-sm mt-5">{errors.eventTime}</p>}
        </div>
      </div>
      {/* Footer Buttons */}
      <div className="flex justify-end gap-4 mt-6">
        <button
          disabled={isButtonDisabled.btnEvent}
          className="w-[103px] h-[40px] bg-[#278EFF] text-white border border-[#278EFF] rounded-lg transition-colors duration-200 hover:bg-white hover:text-[#1A1A1B] disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => onAddEvent(selectedDate, selectedTime)}
        >
          Add
        </button>
        <button className="w-[103px] h-[40px] bg-white text-[#1A1A1B] border border-[#278EFF] rounded-lg transition-colors duration-200 hover:bg-[#278EFF] hover:text-white" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
};

export default AddEvent;
